<template>
  <div class="wrapper">
    <div v-if="!isMobile()">
      <div class="md-layout chat-container">
        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="isLightboxVisible"
          :imgs="imgs"
          :index="index"
          @hide="handleHideLightbox"
        ></vue-easy-lightbox>

        <div
          class="md-layout-item md-size-25 md-small-size-35 md-xmall-size-50 bg-light"
          style="height: 100%; padding: 0px;"
        >
          <div class="messages">
            {{ $t("Messages") }}
            <md-button
              class="md-primary md-just-icon md-round find-interlocutor-btn"
              @click="findInterlocutor(true)"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </div>
          <div class="interlocutors-box">
            <div v-if="chatUsers.length > 0">
              <div
                class="md-layout-item md-layout chat-user"
                v-for="item in chatUsers"
                :key="item.id"
                :class="{ 'active': item.id == activeChatUserId }"
                @click="userPressed(item.id)"
              >
                <div class="avatar-container">
                  <img
                    :src="item.avatarUrl"
                    :alt="item.name"
                    style="max-width:45px !important;border-radius:10px"
                    @error="imgNotLoaded"
                  />
                </div>
                <div
                  class="md-layout-item"
                  style="padding-left:4px !important; padding-right: 4px !important;"
                >
                  <div>
                    <div class="md-layout-item">
                      <strong>{{ item.isInformationAccount ? $t('Information Stand') : item.name }}</strong>
                    </div>
                    <div>
                      <small>{{ getDateString(item.sendDate) }}</small>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item" style="padding-right: 4px !important;">
                      <p
                        class="text-small text-ellipsis"
                      >{{ item.message != null ? item.message : item.lastApiMessage }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="no-messages">
              <strong>{{ $t("Invite someone to conversation") }}</strong>
              <div>
                <md-button
                  class="md-primary md-just-icon md-round"
                  style="margin-top: 8px;"
                  @click="findInterlocutor(true)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="currentUserChatConfiguration != null"
          class="md-layout md-layout-item md-size-75 md-small-size-65 md-xmall-size-50 bg-white chat-config"
        >
          <div class="chat-navbar md-layout md-layout-item md-size-100">
            <div
              v-if="currentUser != null"
              class="md-layout md-layout-item md-size-100 md-alignment-center-center"
              style="margin: 0px !important;"
            >
              <div class="md-layout-item md-size-100" style="padding: 10px 0px 0px 0px !important;">
                <div style="float: left; margin: 8px;">
                  <strong>{{ currentUser.isInformationAccount ? $t('Information Stand') : currentUser.name }}</strong>
                </div>

                <drop-down style="float:right">
                  <md-button
                    id="contactMenuBtn"
                    slot="title"
                    style="padding:0px !important;width:30px"
                    class="md-simple md-sm dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <i class="material-icons">more_horiz</i>
                  </md-button>
                  <ul
                    class="dropdown-menu dropdown-menu-right dropdown-with-icons"
                    style="cursor: pointer;"
                  >
                    <li v-if="currentUserChatConfiguration.isHeBlocked">
                      <a @click="blockUnblockPressed">
                        <i class="material-icons">remove_circle_outline</i>
                        {{ $t('Unblock') }}
                      </a>
                    </li>
                    <li v-if="!currentUserChatConfiguration.isHeBlocked">
                      <a @click="blockUnblockPressed">
                        <i class="material-icons">block</i>
                        {{ $t('Block') }}
                      </a>
                    </li>
                  </ul>
                </drop-down>
              </div>
            </div>
          </div>

          <div
            v-if="currentUserChatConfiguration.invitationAccepted"
            class="messages-container md-layout-item md-size-100"
          >
            <div id="chat-box" class="chat-box">
              <div v-if="showLoadOlderMessages" class="show-older-messages-label">
                <a
                  style="cursor: pointer;"
                  @click="loadOlderMessages()"
                >{{ $t('Load older messages') }}</a>
              </div>
              <div v-for="item in messages" v-bind:key="item.id">
                <div v-if="item.showDate" class="date-entry">{{ getDateString(item.sendDate) }}</div>
                <div
                  class="bubble-container"
                  v-if="!item.isWaitingToSend"
                  v-bind:class="{ 'my': item.senderId == userId }"
                >
                  <div
                    class="rounded"
                    v-bind:class="{
                'bg-me': item.fileId == null && item.senderId == userId,
                'bg-interlocutor': item.fileId == null && item.senderId != userId,
                'bg-transparent': item.isImage,
                'chat-entry': !item.isImage,
                'chat-entry-image': item.isImage,
              }"
                  >
                    <div v-if="item.panelId">
                      <strong style="cursor:pointer">
                        <a
                          style=" text-decoration:underline !important; font-size:14px"
                          @click.prevent="goToPanel(item.panelId)"
                        >{{item.panel[language.code].topic}}</a>
                      </strong>
                      <p>{{item.panel[language.code].description}}</p>
                    </div>
                    <div class="file-container" v-else-if="item.fileId != null">
                      <img
                        v-if="item.isImage"
                        :src="getFileUrl(item.fileId)"
                        @click="showImage(item.fileId)"
                        style="height: 128px; cursor: pointer;"
                      />
                      <a v-else :href="getFileUrl(item.fileId)">{{ item.message }}</a>
                    </div>
                    <div v-else>{{ item.message }}</div>
                  </div>
                </div>
                <div
                  class="bubble-container"
                  v-if="item.isWaitingToSend"
                  v-bind:class="{ 'my': item.senderId == userId }"
                >
                  <div
                    class="rounded chat-entry bg-light"
                    style="text-align: right; float: right;"
                  >{{ item.message }}</div>
                  <div style="clear: both;">
                    <small>{{$t('Sending...')}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="messages-container md-layout-item md-size-100">
            <div style="height: 100%;">
              <div class="invitations-container">
                {{
                currentUserChatConfiguration.invitationReceived
                ? $t("User {0} has sent you an invitation to chat. Accept or deny the invitation.").replace("{0}", currentUser != null ? currentUser.name : "")
                : currentUserChatConfiguration.invitationSent
                ? $t("The invitation to chat is waiting for acceptance by the recipient.")
                : $t("To start a conversation, user must accept your invitation first.")
                }}
                <div
                  v-if="currentUserChatConfiguration.invitationReceived"
                  style="padding-top: 4px;"
                >
                  <md-button
                    class="md-button md-primary"
                    style="padding: 4px; width: 64px; height: 36px;"
                    @click="acceptInvitation"
                  >{{ $t("Accept") }}</md-button>
                  <md-button
                    class="md-button md-danger"
                    style="padding: 4px; width: 64px; height: 36px;"
                    @click="rejectInvitation"
                  >{{ $t("Deny") }}</md-button>
                </div>
                <div v-else-if="!currentUserChatConfiguration.invitationSent">
                  <md-button
                    class="md-button md-primary"
                    @click="invite"
                  >{{ $t("Invite to conversation") }}</md-button>
                </div>
              </div>
            </div>
          </div>
          <template v-if="currentUserChatConfiguration.invitationAccepted">
            <div
              v-if="currentUserChatConfiguration.amIBlocked ||
                  currentUserChatConfiguration.isHeBlocked ||
                  (!currentUserChatConfiguration.canIChat || !currentUserChatConfiguration.canHeChat)"
              class="chat-type bg-primary md-layout-item md-size-100"
            >
              <div class="inactive-info">
                {{
                currentUserChatConfiguration.amIBlocked
                ? $t("Chat blocked by the user")
                : currentUserChatConfiguration.isHeBlocked
                ? $t("User blocked")
                : !currentUserChatConfiguration.canIChat || !currentUserChatConfiguration.canHeChat
                ? $t("Chat inactive")
                : ""
                }}
              </div>
            </div>
            <div v-else class="chat-type bg-gray md-layout-item md-size-100">
              <div class="md-layout" style="margin: 0px;">
                <div class="md-layout-item">
                  <input
                    id="message-input"
                    v-model="message"
                    v-on:keyup.enter="sendPressed"
                    type="text"
                    placeholder="Type a message"
                    style="width: 100%;"
                    :style="{ fontWeight: textInputFontWeight}"
                    :readonly="file != null || panel != null"
                  />
                  <input ref="file" type="file" @change="attachmentChange" style="display: none" />
                </div>
                <div style="width: 80px; text-align: right;">
                  <template v-if="!panel">
                    <button type="button" @click="attachmentPressed">
                      <i
                        class="fa"
                        :class="[
                      { 'fa-unlink': file != null },
                      { 'fa-paperclip': file == null },
                    ]"
                      ></i>
                    </button>
                    <button       
                      type="button"
                      @click="sendPressed"
                      style="padding-right: 16px;"
                    >
                      <i class="fa fa-paper-plane"></i>
                    </button>
                  </template>
            <template v-else>
                      <button type="button" @click="panel = null">
                      <i
                        class="fa fa-times"                        
                      ></i>
                    </button>
                    <button       
                      type="button"
                      @click="sendPressed"
                      style="padding-right: 16px;"
                    >
                      <i class="fa fa-share"></i>
                    </button>
</template>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="modal modal-bg" :class="{ show: showFindInterlocutorModal }">
          <modal v-if="showFindInterlocutorModal" @close="showFindInterlocutorModal = false">
            <template slot="header">
              <h3 class="title text-center">{{ $t('Write to') }}</h3>
              <md-button
                class="md-simple md-close md-just-icon md-round modal-default-button"
                @click="showFindInterlocutorModal = false"
              >
                <md-icon>clear</md-icon>
              </md-button>
            </template>

            <template slot="body">
              <div class="md-layout-item md-size-100 text-right" style="margin-bottom: 8px">
                <md-field style="margin-bottom: 10px">
                  <md-icon>search</md-icon>
                  <label>{{$t('Search')}}</label>
                  <md-input
                    v-model="tempfilter"
                    v-on:keyup.enter="interlocutors = []; filter = tempfilter"
                  />
                </md-field>
                <md-button
                  style="margin-bottom:15px"
                  class="mr-auto md-round md-primary md-sm md-blue-border"
                  @click="interlocutors = []; filter = tempfilter"
                >{{$t('Search')}}</md-button>
              </div>
              <div style="height: 320px; overflow-y: scroll;">
                <div
                  v-for="(interlocutor, iterator) in interlocutors"
                  v-bind:key="interlocutor.userId"
                >
                  <div
                    class="md-layout"
                    style="padding: 4px !important; margin: 0px !important;"
                    v-bind:class="{
                'bg-light': iterator % 2 == 0,
              }"
                  >
                    <div class="md-layout-item-15" style="padding-right: 8px !important;">
                      <!-- <md-avatar> -->
                      <img
                        :src="interlocutor.avatarUrl"
                        :alt="interlocutor.name"
                        style="max-width:45px !important;border-radius:10px"
                        @error="imgNotLoaded"
                      />
                      <!-- </md-avatar> -->
                    </div>
                    <div
                      class="md-layout-item"
                      style="text-align: left;"
                    >{{ interlocutor.isInformationAccount ? $t('Information Stand') : interlocutor.name }}</div>
                    <div class="md-layout-item-15">
                      <md-button
                        class="md-primary md-just-icon md-round"
                        style="padding: 4px;"
                        @click="startChat(interlocutor)"
                      >
                        <md-icon>chat</md-icon>
                      </md-button>
                    </div>
                  </div>
                </div>

                <scroll-loader :loader-method="findInterlocutor" :loader-disable="!loadMore">
                  <div>{{$t('Loading')}}...</div>
                </scroll-loader>
              </div>
            </template>
          </modal>
        </div>
      </div>
    </div>
    <div v-else class="wrapper">
      <div class="md-layout" style="padding-top:80px;">
        <h4
          class="regular md-layout-item md-size-80 mx-auto"
          style="margin-bottom:20px"
        >{{ $t('Chat in the mobile version is available only with applications to download from Google Play and Appstore.') }}</h4>

        <md-button
          class="md-layout-item md-size-80 mx-auto md-primary"
          href="https://play.google.com/store/apps/details?id=org.economicforum.forum.application"
        >Google Play</md-button>

        <md-button
          class="md-layout-item md-size-80 mx-auto md-primary"
          style="margin-top: 12px;"
          href="https://apps.apple.com/pl/app/economic-forum/id1477498525"
        >App Store</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Modal } from "@/components";
import axios from "@/util/axios";
import user from "@/util/store/user";
import Lightbox from "vue-easy-lightbox";
import Vue from "vue";

Vue.use(Lightbox);

export default {
  components: {
    Modal
  },
  bodyClass: "landing-page",
  data() {
    return {
      id: null,
      userId: null,
      recentId: null,
      activeChatUserId: null,
      chatUsers: [],
      messages: [],
      message: null,
      srMessages: [],
      emptyMessage: true,
      file: null,
      isLightboxVisible: false,
      imgs: "",
      index: 0,
      showLoadOlderMessages: false,
      currentUserChatConfiguration: null,
      currentUser: null,
      interlocutors: [],
      showFindInterlocutorModal: false,
      searchQuery: null,
      loadMore: true,
      take: 400,
      tempfilter: null,
      filter: null,
      panel: null
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      sentMessages: "hub/sentMessages",
      receivedMessages: "hub/receivedMessages",
      messagesToSend: "hub/messagesToSend",
      uploadingFiles: "hub/uploadingFiles",
      newContacts: "hub/newContacts",
      rejectedContactsIds: "hub/rejectedContactsIds",
      chatConfiguration: "hub/chatConfiguration",
      isConnectionEstablished: "hub/isConnectionEstablished",
      token: "user/token"
    }),
    textInputFontWeight(){
      return this.panel ? 800 : 400;
    },
    skip() {
      return this.interlocutors.length;
    }
  },
  methods: {
    goToPanel(id) {
      var route = this.$router.resolve({
        name: "panelDetails",
        params: { id: id }
      });
      window.open(route.href, "_blank");
    },
    getFileUrl(fileId) {
      return axios.getFileUrl(fileId);
    },
    showImage(fileId) {
      var imgUrl = this.getFileUrl(fileId);
      this.imgs = imgUrl;

      this.showLightbox();
    },
    imgNotLoaded(event) {
      event.target.src = require("@/assets/img/blank_avatar.png");
    },
    showLightbox() {
      this.isLightboxVisible = true;
    },
    handleHideLightbox() {
      this.isLightboxVisible = false;
    },
    userPressed(id) {
      this.activeChatUserId = id;
    },
    attachmentPressed() {
      if (this.file == null) {
        this.$refs.file.click();
      } else {
        this.file = null;
        this.$refs.file.value = "";
        this.message = null;
      }
    },
    async attachmentChange() {
      this.file = this.$refs.file.files[0];
      if (this.file != null) {
        this.message = this.file.name;
      }
    },
    async blockUnblockPressed() {
      if (this.currentUserChatConfiguration.isHeBlocked) {
        await this.unblockUser();
      } else {
        await this.blockUser();
      }
    },
    async blockUser() {
      await this.$store.dispatch("hub/blockUser", this.activeChatUserId);
    },
    async unblockUser() {
      await this.$store.dispatch("hub/unblockUser", this.activeChatUserId);
    },
    async invite() {
      await this.$store.dispatch("hub/invite", this.activeChatUserId);
    },
    async acceptInvitation() {
      await this.$store.dispatch("hub/acceptInvitation", this.activeChatUserId);
    },
    async rejectInvitation() {
      var result = await this.$store.dispatch(
        "hub/rejectInvitation",
        this.activeChatUserId
      );
      if (result) {
        this.currentUserChatConfiguration = null;
        this.currentUser = null;
        this.activeChatUserId = null;
      }
    },
    async sendPressed() {
      let self = this;
      let text = this.message;

      if (text == null || text == "") {
        return;
      }

      this.message = null;

      if (this.file != null) {
        let fileToUpload = this.file;
        this.file = null;

        var payload = {
          recipientId: this.activeChatUserId,
          filename: text,
          mimeType: fileToUpload.type
        };

        await self.$store.dispatch("hub/addSendingFile", payload);

        let formData = new FormData();
        formData.append("file", fileToUpload);
        axios
          .post("/files", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(async result => {
            var uploadedFilePayload = {
              recipientId: payload.recipientId,
              fileId: result.data.id,
              filename: result.data.name,
              mimeType: fileToUpload.type
            };

            await self.$store.dispatch("hub/sendFile", uploadedFilePayload);
            self.scrollToBottom();
          })
          .catch(error => {
            console.log(error);
          });
      }
      else if (this.panel){
         var payload = {
          recipientId: this.activeChatUserId,
          panelId: this.panel.id,
          message: text
        };


        await this.$store.dispatch("hub/sendMessage", payload);
        this.panel = null;
      }
      else {
        var payload = {
          recipientId: this.activeChatUserId,
          message: text
        };

        await this.$store.dispatch("hub/sendMessage", payload);
      }

      this.scrollToBottom();
    },
    getDateString(date) {
      if (date == undefined) {
        return "";
      }

      var now = new Date();

      if (
        now.getFullYear() == date.getFullYear() &&
        now.getMonth() == date.getMonth() &&
        now.getDate() == date.getDate()
      ) {
        return (
          this.$t("Today") +
          " " +
          date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        );
      }

      // yesterday
      now.setDate(now.getDate() - 1);

      if (
        now.getFullYear() == date.getFullYear() &&
        now.getMonth() == date.getMonth() &&
        now.getDate() == date.getDate()
      ) {
        return (
          this.$t("Yesterday") +
          " " +
          date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        );
      }

      return date.toLocaleString([], { dateStyle: "long", timeStyle: "short" });
    },
    async getChatData(shouldSetActiveUser) {
      let self = this;

      await this.getChatUsersHistory();

      if (this.chatUsers.length > 0) {
        this.setChatUsersLastMessagesAndSort();

        if (shouldSetActiveUser) {
          this.activeChatUserId = this.chatUsers[0].id;
        }
      }
    },
    loadOlderMessages() {
      let self = this;
      var activeChatUserIndex = this.findWithAttr(
        self.chatUsers,
        "id",
        self.activeChatUserId
      );
      var oldestDate = new Date(
        Math.min.apply(
          null,
          this.chatUsers[activeChatUserIndex].apiMessages.map(function(item) {
            return item.sendDate;
          })
        )
      );

      this.getUsersMessageHistory(oldestDate);
    },
    async startChat(interlocutor) {
      let self = this;
      var activeChatUserIndex = this.findWithAttr(
        self.chatUsers,
        "id",
        interlocutor.userId
      );

      if (activeChatUserIndex == -1) {
        var newContact = {
          id: interlocutor.userId,
          isInformationAccount: interlocutor.isInformationAccount,
          name: interlocutor.name,
          avatarUrl:
            interlocutor.avatarUrl != null
              ? interlocutor.avatarUrl
              : axios.getUserAvatarUrl(null),
          apiMessages: [],
          sendDate: new Date()
        };

        this.chatUsers = [newContact].concat(this.chatUsers);
      }

      this.activeChatUserId = interlocutor.userId;

      if (interlocutor.isInformationAccount) {
        await this.invite();
      }

      this.showFindInterlocutorModal = false;
    },
    async findInterlocutor(clear) {
      if (clear) {
        this.interlocutors = [];
      }

      let self = this;
      let loader = this.$loading.show();

      try {
        var subItems = (
          await axios.get("/chat/users/active", {
            params: {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type,
              filter: self.filter,
              skip: self.skip,
              take: self.take
            }
          })
        ).data;

        subItems = subItems.map(function(interlocutor) {
          return {
            userId: interlocutor.userId,
            avatarUrl: axios.getUserAvatarUrl(interlocutor.externalId),
            isInformationAccount: interlocutor.isInformationAccount,
            name: interlocutor.firstName + " " + interlocutor.lastName
          };
        });

        var oldLength = this.interlocutors.length;

        let temp = this.interlocutors.concat(subItems);
        this.interlocutors = [
          ...new Map(temp.map(item => [item.userId, item])).values()
        ];

        this.loadMore = oldLength < this.interlocutors.length;
        this.showFindInterlocutorModal = true;
      } finally {
        loader.hide();
      }
    },
    async getUsersMessageHistory(beforeThan) {
      let self = this;

      if (self.activeChatUserId != null) {
        var messages = (
          await axios.get("/chat/messages", {
            params: {
              userId: self.activeChatUserId,
              beforeThan: beforeThan
            }
          })
        ).data;

        this.showLoadOlderMessages = messages.length == 100;

        var activeChatUserIndex = this.findWithAttr(
          self.chatUsers,
          "id",
          self.activeChatUserId
        );
        if (activeChatUserIndex > -1) {
          this.currentUser = this.chatUsers[activeChatUserIndex];

          var apiMessages = messages.map(function(message) {
            return {
              id: message.id,
              senderId: message.senderId,
              recipientId: message.recipientId,
              message: message.message,
              sendDate: new Date(message.sendDate),
              fileId: message.fileId,
              isImage: message.fileMimeType?.includes("image") ?? false,
              isNew: false,
              isWaitingToSend: false,
              showDate: false,
              panelId: message.panelId,
              panel: message.panel
            };
          });

          if (beforeThan == null) {
            this.chatUsers[activeChatUserIndex].apiMessages = apiMessages;
          } else {
            this.chatUsers[
              activeChatUserIndex
            ].apiMessages = apiMessages.concat(
              this.chatUsers[activeChatUserIndex].apiMessages
            );
            this.getCurrentUserMessages();
          }
        }
      }
    },
    async getChatConfiguration() {
      let self = this;

      if (self.activeChatUserId != null) {
        var configuration = (
          await axios.get("/chat/users/settings", {
            params: {
              userId: self.activeChatUserId
            }
          })
        ).data;

        this.currentUserChatConfiguration = configuration;
      } else {
        this.currentUserChatConfiguration = null;
      }
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    setChatUsersLastMessagesAndSort() {
      if (this.srMessages.length > 0) {
        var lastMessage = this.srMessages[this.srMessages.length - 1];
        var interlocutorId =
          lastMessage.senderId == this.userId
            ? lastMessage.recipientId
            : lastMessage.senderId;

        var interlocutor = this.chatUsers.find(function(item) {
          return item.id == interlocutorId;
        });

        interlocutor.message = lastMessage.message;
        interlocutor.sendDate = new Date(lastMessage.sendDate);
        interlocutor.isNew = lastMessage.isNew;
      } else {
        for (var i in this.chatUsers) {
          var user = this.chatUsers[i];
          if (user.apiMessages.length > 0) {
            var lastMessage = user.apiMessages[user.apiMessages.length - 1];
            user.message = lastMessage.message;
            user.sendDate = lastMessage.sendDate;
            user.isNew = lastMessage.isNew;
          } else {
            user.sendDate = user.lastContactDate;
          }
        }
      }

      this.sortChatUsers();
    },
    getCurrentUserMessages() {
      let self = this;
      var isScrolledToBottom = this.isScrolledToBottom();

      var messages =
        this.chatUsers.filter(function(item) {
          return item.id == self.activeChatUserId;
        })[0]?.apiMessages ?? [];

      var srMessages = this.srMessages.filter(function(item) {
        return (
          item.senderId == self.activeChatUserId ||
          item.recipientId == self.activeChatUserId
        );
      });

      messages = messages.concat(srMessages);

      messages = Array.from(new Set(messages.map(s => s.id))).map(id => {
        return {
          id: id,
          senderId: messages.find(s => s.id === id).senderId,
          recipientId: messages.find(s => s.id === id).recipientId,
          message: messages.find(s => s.id === id).message,
          sendDate: new Date(messages.find(s => s.id === id).sendDate),
          fileId: messages.find(s => s.id === id).fileId,
          isImage: messages.find(s => s.id === id).isImage,
          isNew: messages.find(s => s.id === id).isNew,
          isWaitingToSend: messages.find(s => s.id === id).isWaitingToSend,
          panelId: messages.find(s => s.id === id).panelId,
          panel: messages.find(s => s.id === id).panel,
          showDate: false
        };
      });

      messages = messages.sort(function(a, b) {
        return new Date(a.sendDate) - new Date(b.sendDate);
      });

      // calculate if the date should be shown
      if (messages.length > 0) {
        messages[0].showDate = true;

        for (var i = 1; i < messages.length; ++i) {
          var previousMessageDate = messages[i - 1].sendDate;
          var currentMessageDate = messages[i].sendDate;

          if (
            !(
              previousMessageDate.getFullYear() ==
                currentMessageDate.getFullYear() &&
              previousMessageDate.getMonth() == currentMessageDate.getMonth() &&
              previousMessageDate.getDate() == currentMessageDate.getDate()
            )
          ) {
            messages[i].showDate = true;
          }
        }
      }

      this.messages = messages;

      if (isScrolledToBottom) {
        this.scrollToBottom();
      }
    },
    combineHubMessages() {
      var temp = [];
      var sent = this.sentMessages;
      var received = this.receivedMessages;
      var toSend = this.messagesToSend;
      var sending = this.uploadingFiles;

      temp = sent.concat(received);

      if (sent.length > 0) {
        var recent = sent[sent.length - 1];
        var recentDate = new Date(recent.sendDate);

        if (recent.id != this.recentId) {
          if (toSend.length > 0) {
            var itemsToRemove = toSend.filter(function(item) {
              return (
                item.message == recent.message && recentDate > item.sendDate
              );
            });
            if (itemsToRemove.length > 0) {
              toSend = toSend.filter(function(item) {
                return item.id != itemsToRemove[0].id;
              });
            }
          }
          if (sending.length > 0) {
            var itemsToRemove = sending.filter(function(item) {
              return (
                item.message == recent.message && recentDate > item.sendDate
              );
            });
            if (itemsToRemove.length > 0) {
              sending = sending.filter(function(item) {
                return item.id != itemsToRemove[0].id;
              });
            }
          }

          this.recentId = recent.id;
        }
      }

      temp = temp.concat(toSend);
      temp = temp.concat(sending);

      temp = temp.sort(function(a, b) {
        return a.sendDate > b.sendDate ? 1 : 0;
      });

      this.srMessages = temp;
    },
    combineInvitationUsers() {
      let self = this;

      var chatUsersIds = this.chatUsers.map(function(chatUser) {
        return chatUser.id;
      });

      var filteredNewContacts = this.newContacts.filter(function(contact) {
        return !chatUsersIds.some(function(item) {
          return item == contact.userId;
        });
      });

      var newChatUsers = filteredNewContacts.map(function(item) {
        return {
          id: item.userId,
          externalId: item.externalUserId,
          isInformationAccount: item.isInformationAccount,
          name: item.firstName + " " + item.lastName,
          avatarUrl: axios.getUserAvatarUrl(item.externalUserId),
          sendDate: new Date(item.lastContactDate),
          lastApiMessage: item.lastMessage,
          apiMessages: []
        };
      });

      this.chatUsers = this.chatUsers.concat(newChatUsers);
      this.chatUsers = this.chatUsers.filter(function(chatUser) {
        return !self.rejectedContactsIds.some(function(item) {
          return item == chatUser.id;
        });
      });

      var rejectCurrentActiveUser = this.rejectedContactsIds.some(function(
        item
      ) {
        return item == self.activeChatUserId;
      });

      if (rejectCurrentActiveUser) {
        this.currentUserChatConfiguration = null;
        this.currentUser = null;
        this.activeChatUserId = null;
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        var out = document.getElementById("chat-box");
        if (out != null) {
          out.scrollTop = out.scrollHeight - out.clientHeight + 1;
        }
      });
    },
    isScrolledToBottom() {
      var out = document.getElementById("chat-box");
      if (out != null) {
        return out.scrollHeight - out.clientHeight <= out.scrollTop + 1;
      }
      return false;
    },
    sortChatUsers() {
      this.chatUsers = this.chatUsers.sort(function(a, b) {
        return new Date(b.sendDate) - new Date(a.sendDate);
      });
    },
    async tryToReconnect() {
      let self = this;

      setTimeout(async function() {
        var result = await self.$store.dispatch("hub/openChatConnection");
        if (!result) {
          self.tryToReconnect();
        }
      }, 5000);
    },
    async getChatUsersHistory() {
      var list = (await axios.get("/chat/users/history")).data;

      this.chatUsers = list.map(function(item) {
        return {
          id: item.userId,
          externalId: item.externalUserId,
          isInformationAccount: item.isInformationAccount,
          name: item.firstName + " " + item.lastName,
          avatarUrl: axios.getUserAvatarUrl(item.externalUserId),
          lastContactDate: new Date(item.lastContactDate),
          lastApiMessage: item.lastMessage,
          apiMessages: []
        };
      });
    },
    async startNewChat() {
      let self = this;

      if (this.id != undefined) {
        var interlocutors = (
          await axios.get("/chat/users/active", {
            params: {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type
            }
          })
        ).data;

        interlocutors = interlocutors
          .filter(function(interlocutor) {
            return interlocutor.userId == self.id;
          })
          .map(function(interlocutor) {
            return {
              userId: interlocutor.userId,
              avatarUrl: axios.getUserAvatarUrl(interlocutor.externalId),
              isInformationAccount: interlocutor.isInformationAccount,
              name: interlocutor.firstName + " " + interlocutor.lastName
            };
          });

        if (interlocutors.length > 0) {
          this.startChat(interlocutors[0]);
        }
      }
    },
    shouldRefreshContactsList() {
      let self = this;

      return this.receivedMessages.some(function(item) {
        return !self.chatUsers.some(function(user) {
          return user.id == item.senderId;
        });
      });
    },
    isMobile() {
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  async mounted() {
    let loader = this.$loading.show();

    try {
      this.id = this.$route.params.id;
      this.panel =this.$route.params.panel;      
      this.userId = await this.$store.dispatch("user/getUserId");

      await this.getChatData(true);
      await this.startNewChat();
    } finally {
      loader.hide();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.activeChatUserId = null;
    next();
  },
  watch: {
    isConnectionEstablished: function(newValue) {
      if (!newValue) {
        this.tryToReconnect();
      }
    },
    activeChatUserId: async function(newValue) {
      let loader = this.$loading.show();
      try {
        this.getChatConfiguration();
        await this.getUsersMessageHistory(null);
        this.getCurrentUserMessages();
        this.scrollToBottom();

        this.$store.commit("hub/setCurrentInterlocutorId", newValue);
        this.$store.dispatch("hub/setInterlocutorMessagesAsRead", newValue);
      } finally {
        loader.hide();
      }
    },
    sentMessages: function() {
      this.combineHubMessages();
    },
    receivedMessages: async function() {
      if (this.shouldRefreshContactsList()) {
        await this.getChatData(false);
      }
      this.combineHubMessages();
    },
    messagesToSend: function() {
      this.combineHubMessages();
    },
    uploadingFiles: function() {
      this.combineHubMessages();
    },
    rejectedContactsIds: function() {
      // this.combineInvitationUsers();
      // this.sortChatUsers();
    },
    newContacts: function() {
      this.combineInvitationUsers();
      this.sortChatUsers();
    },
    srMessages: function() {
      this.getCurrentUserMessages();
      this.setChatUsersLastMessagesAndSort();
      this.sortChatUsers();
    },
    panel: function(value){      
        this.message = !!value ? value.name : null;      
    },
    message: function(newValue) {
      this.emptyMessage = newValue == "" || newValue == null;
    },
    chatConfiguration: function(newValue) {
      if (
        newValue != null &&
        newValue.interlocutorId == this.activeChatUserId
      ) {
        this.currentUserChatConfiguration = newValue;
      }
    },
    async filter() {
      this.loaded = false;
      this.loadMore = false;
      this.interlocutors = [];
      await this.findInterlocutor();
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-container {
  position: absolute;
  width: 100%;
  height: calc(100% - 70px);
  margin: 70px 0px 0px 0px !important;
  font-weight: 400 !important;
  color: #3c4858 !important;
}

.mobile-container {
  position: absolute;
  width: 100%;
  height: calc(100% - 70px);
  margin: -20px 0px 0px 0px !important;
  background-color: #fff;
  text-align: center;
  font-weight: 400 !important;
  color: #3c4858 !important;
}

.chat-type {
  height: 64px;
  padding: 8px;

  input {
    height: 48px;
    border: 0px;
    background: transparent;
    font-size: 14px;
  }

  button {
    height: 48px;
    cursor: pointer;
    background: transparent;
    border: 0px;
    font-size: 18px;
  }

  button:hover {
    color: #3678b6 !important;
  }
}

.inactive-info {
  margin-top: 16px;
  text-align: center;
  font-weight: bold;
}

.chat-config {
  height: calc(100% - 64px);
  padding: 0px;
}

.chat-navbar {
  padding: 4px;
  height: 64px;
  border-bottom: 1px solid #f8f9fa !important;
}

.transparent-btn {
  cursor: pointer;
  background: transparent;
  border: 0px;
  font-size: 18px;
}

.avatar-container {
  width: 48px;
  text-align: center;
  margin-left: 4px;
  margin-right: 4px;
}

.chat-box {
  width: 100%;
  padding: 0px 8px 8px 8px;
}

.messages {
  position: relative;
  height: 64px;
  padding: 22px 12px 12px 12px;
  text-align: left;
  font-weight: bold;
  border-bottom: 1px solid #e8e9ea;
}

.invitations-container {
  position: relative;
  top: calc(50%);
  margin: 0;
  transform: translate(0, -50%);
  text-align: center;
  font-weight: bold;
}

.interlocutors-box {
  height: calc(100% - 64px);
  overflow-y: scroll;
}

.messages-container {
  width: 100%;
  height: calc(100% - 64px);
  //overflow-y: scroll;
}

.find-interlocutor-btn {
  position: absolute;
  top: 8px;
  right: 4px;
}

.show-older-messages-label {
  text-align: center;
  margin-top: 16px;
}

.chat-box {
  height: 100%;
  overflow-y: scroll;
}

.no-messages {
  position: relative;
  margin: 0;
  width: 100%;
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.bubble-container {
  margin: 4px 2px 4px 2px !important;
  clear: both;
  float: left;
}

.my {
  float: right !important;
}

.chat-entry {
  padding: 8px;
  vertical-align: middle;
  display: table-cell;
  font-size: 14px;
}

.chat-entry-image {
  vertical-align: middle;
  display: table-cell;
  font-size: 14px;
}

.date-entry {
  width: 100%;
  padding-top: 8px;
  font-size: 14px;
  text-align: center;
  float: left;
}

.chat-user {
  padding-top: 8px;
  padding-bottom: 4px;
  border-top: 1px solid #dedede;
}

.chat-user:hover {
  background: #fff;
  cursor: pointer;
}

.rounded-lg {
  border-radius: 0.5rem;
}

input::placeholder {
  font-size: 0.9rem;
  color: #999;
}

.file-container a {
  color: #fff !important;
  text-decoration: underline;
}

.bg-white {
  background: #fff;
}

.bg-light {
  background: #f8f9fa !important;
}

.bg-gray {
  background: #e8e9ea !important;
}

.bg-primary {
  background-color: #3678b6 !important;
  color: #fff !important;
}

.bg-danger {
  background-color: #ff0500 !important;
  color: #fff !important;
}

.bg-me {
  background-color: #e8eaf6 !important;
  color: #000 !important;
}

.bg-interlocutor {
  background-color: #f5f5f5 !important;
  color: #000 !important;
}

.bg-transparent {
  background-color: transparent !important;
  color: #000 !important;
}

.active {
  background-color: #3678b6 !important;
  color: #fff !important;
}

.active small {
  color: #fff !important;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  width: 5px;
  background: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  width: 1em;
  background-color: #ddd;
  outline: 1px solid slategrey;
  border-radius: 1rem;
}

.text-small {
  font-size: 0.9rem;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
